import { motion } from 'framer-motion';
import { teamMembers } from '@data/team';
import './TeamSection.css';

// Calculate dynamic experience based on current year
const calculateExperience = (baseExperience, baseYear) => {
    const currentYear = new Date().getFullYear();
    const yearsToAdd = currentYear - baseYear;
    const totalExperience = baseExperience + yearsToAdd;
    return `${totalExperience}+ yrs`;
};

const TeamSection = () => {
    // Animation variants for team cards
    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (index) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: index * 0.15,
                duration: 0.6,
                ease: 'easeOut'
            }
        })
    };

    return (
        <section className="team-section">
            <div className="team-container">
                <div className="team-header">
                    <h2 className="team-title">Our Thinktank</h2>
                    <p className="team-subtitle">
                        Our Team Members who have contributed immensely to our Growth
                    </p>
                </div>

                <div className="team-grid">
                    {teamMembers.map((member, index) => (
                        <motion.div
                            key={member.id}
                            className="team-card"
                            custom={index}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            variants={cardVariants}
                        >
                            <div className="team-info">
                                <h3 className="team-name">{member.name}</h3>
                                <div className="team-role">{member.title}</div>
                                {member.qualifications && (
                                    <div className="team-qualifications">{member.qualifications}</div>
                                )}
                                <div className="team-experience">
                                    {calculateExperience(member.baseExperience, member.baseYear)}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TeamSection;